import { useCallback } from "react";
import type { Vehicle } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchVehicle = (
    vehicleId?: string | null,
): UseFetchActionReturn<Vehicle | undefined> => {
    const fetchVehicle: () => Promise<Vehicle | undefined> = useCallback(() => {
        if (vehicleId) {
            return store.vehiclesApi.vehiclesReadVehicle({ vehicleId });
        } else {
            return Promise.resolve(undefined);
        }
    }, [vehicleId]);
    return useFetchAction(fetchVehicle);
};
